import React, { PropTypes } from 'react';
import { IconButton } from 'material-ui';
import moment from 'moment-timezone';
import ClockSVG from 'material-ui/svg-icons/action/query-builder';
import GlobalSVG from 'material-ui/svg-icons/action/language';

const Timestamp = props => {
  const {
    timestamp,
  } = props;

  const timeFromNow = moment(timestamp).from(moment());

  return (
    <div style={{ clear: 'both', padding: '0 2%', margin: '3px 0 0 -5px', fontSize: '12px' }}>
      <span>
        <ClockSVG color="rgba(0, 0, 0, 0.54)" style={{ height: '12px', verticalAlign: 'middle', marginTop: '-2px' }} />
        {timeFromNow}
        { /*
        <IconButton tooltip="Public" iconStyle={{ height: '12px', verticalAlign: 'top' }}>
          <GlobalSVG color="rgba(0, 0, 0, 0.54)" />
        </IconButton>
        */}
      </span>
    </div>
  );
};

Timestamp.propTypes = {
  timestamp: PropTypes.string,
};

export default Timestamp;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/timestamp.jsx